<template>
    <div class="flex flex-col items-start gap-4 rounded-lgr border border-card-border bg-surface-raised p-5">
        <!-- iconTile is a self-contained decorative tile (own size, background wash, and radius
             baked in, e.g. SetupCalendarTile) rather than a glyph meant for the neutral swatch box. -->
        <component :is="iconTile" v-if="iconTile" />
        <div v-else class="flex size-12 items-center justify-center rounded-lg bg-surface">
            <img v-if="iconSrc" :src="iconSrc" alt="" class="size-8 object-contain" />
            <component :is="icon" v-else class="size-8 text-ink" />
        </div>
        <div class="flex flex-col gap-1">
            <h3 class="font-serif font-medium text-[20px] leading-[1.16] text-ink">{{ title }}</h3>
            <p class="body-small text-ink-muted">{{ body }}</p>
        </div>
        <BaseButton theme="neutral" size="sm" class="w-full" :disabled="connected" @click="emit('cta-click')">
            <template v-if="connected"><i class="bi bi-check-lg" aria-hidden="true" /> {{ completedLabel }}</template>
            <template v-else>{{ ctaLabel }}</template>
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import type { Component } from "vue";

export interface ConnectContextCardProps {
    title: string;
    body: string;
    ctaLabel: string;
    icon?: Component;
    iconSrc?: string;
    /** A self-contained decorative tile (own background/size/radius), rendered without the neutral swatch box. */
    iconTile?: Component;
    connected: boolean;
    /** "Connected" fits an integration (calendar, Work IQ); "Completed" fits a one-time task (Perspective, Collaboration Profile). */
    completedLabel?: string;
}

withDefaults(defineProps<ConnectContextCardProps>(), { completedLabel: "Connected" });

const emit = defineEmits<{ "cta-click": [] }>();
</script>
